<template>
  <div>
	<div class="row">
    <div class="col-md-12" style="display: block ruby;">
		  <h1 class="">Market Value</h1>
    </div>
    
    <div class="col-sm-12">
      <div class="pull-right form-group">
        <label>Market Value for </label><date-picker :disabled-date="disabledDates" input-class="form-control" ref="market_date" value-type="format" v-model="tableData.market_date" format='DD-MM-YYYY' readonly></date-picker>
        <div class="mt-2" style="display:flow-root;" v-if="can_access('marketvalue','upload')">

          <a href="javascript:;" class="pull-right ml-3" @click="showModal('default-margin-rate')" v-if="can_access('marketvalue','upload')">Upload Market Value CSV</a>

          <a href="javascript:;" class="pull-right" title="Change Account Margin Rate" @click="AccountMarginRate">Change Account Margin Rate</a>
        </div> 
      </div>
    </div>
		<TableView :col="columns" :getData="getData" v-if="!refreshView"/>
    <div class="col-sm-12" v-if="can_access('marketvalue','modify')">
      <b-button class="btn btn-lg btn-info pull-right" title="Save Market Values" @click="addMarketValue"><i class="fa fa-save"></i> Save</b-button>
    </div>
	</div>
  <b-modal ref="account-margin-rate" title="Change Account Margin Rate" size="lg" hide-footer v-if="showAddAccountMarginRate && can_access('marketvalue','modify')">
      <div class="col-sm-12"><MarginRatePage :type="'account'"/></div>
  </b-modal>

  <b-modal ref="default-margin-rate" title="Default Margin Rate" size="lg" hide-footer v-if="showAddDefaultMarginRate && can_access('marketvalue','modify')">
      <div class="col-sm-12"><MarginRatePage :type="'default'"/></div>
      <b-button class="btn btn-lg btn-info pull-right" title="Confirm Default Market Values" @click="confirmMarketValue">Next <i class="fa fa-arrow-right"></i></b-button>
  </b-modal>

  <b-modal ref="upload-deal-ticket-out" title="Upload Market Values" size="xl" hide-footer v-if="can_access('marketvalue','upload')">
    <p class="my-4"><UploadDealTicketForm @forceRerender="uploadMarketValueFormReRender" uri="import_market_value" sample_file="market_value_sample" note="*As like as in the sample file first column must be date, and for the further columns you can add/remove the new/existing security ticker name"/></p>
  </b-modal>
  </div>
</template>
<script>
import moment from 'moment';
import common from '@/assets/js/common.js';

export default {
  name: 'MarketValuePage',
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
    DatePicker : () => import('vue2-datepicker') ,
    Widget : () => import('@/components/Widget/Widget') ,
    UploadDealTicketForm : () => import('@/components/Accounts/UploadTradesCSV'),
    MarginRatePage : () => import('@/pages/Accounts/MarginRate')
  },
  mixins: [common],
  data() {
    return {
      showAddAccountMarginRate: true,
      showAddDefaultMarginRate: true,
    	tableData: {
        'market_date': this.getLastWorkingDate(),
      },
      refreshView: false,
      errorMessage: null,

      columns: (() => {
        const cols = [
          { title: 'Stock Name', field: 'stock_name', sortable: true, thComp: 'FilterTh' },
          { title: 'Ticker', field: 'ticker', sortable: true, thComp: 'FilterTh' },
          { title: 'Market Price', field: 'market_value', sortable: false, tdComp: 'Input' },
          { title: 'Margin %', field: 'margin', sortable: false, tdComp: 'Input'}
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    };
  },
  watch: {
    'tableData.market_date': function(newValue){
      if(moment(newValue,'DD-MM-YYYY').isBefore(moment())){
        this.refreshView = true;
        this.$nextTick(function(){
          this.refreshView = false;
        });
      }else{
        this.tableData.market_date = moment().subtract(1, 'days').format("DD-MM-YYYY");
      }
    }
  },
  methods: {
    showModal(model) {
      this.$refs[model].show()
    },
    confirmMarketValue(){
      this.$refs['default-margin-rate'].hide()
      this.showModal('upload-deal-ticket-out');
    },
    uploadMarketValueFormReRender(response){
      if(response.code==0){
          this.$refs['upload-deal-ticket-out'].hide()
          this.refreshView = true;
          this.$nextTick(function(){
            this.refreshView = false;
          });
      }
    },
    AccountMarginRate(){
      this.$refs['account-margin-rate'].show()
    },
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      this.columns.forEach(col => {
        if (query[col.nested||col.field]) {
          filter[col.nested||col.field] = query[col.nested||col.field];
        }else{
          delete filter[col.nested||col.field];
        }
      });
      filter['market_date'] = this.tableData.market_date;
			let uri = 'get_instruments_by_trades?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
			const res = await this.call_axios(uri);
			//res.response.data.Pagination = false;
			this.tableData =  {
        'market_date': this.tableData.market_date,
      };
      Object.assign(this.tableData, res.response.data.result);
			return res;
    },
    addMarketValue: async function(){
      //console.log(this.tableData,this.tableData.market_date)
      const {response} = await this.call_axios('add_market_value', 'post', {data:this.tableData}); 
      this.$toasted.success("Successfully Added",{duration:1000});    
    },
    disabledDates(date){
      if(moment(date).isAfter(moment())) return true;
      return false;
    }
  },
  created() {
    
  },
};
</script>